import { WishlistPage } from './wishlist.component';
import { connect } from 'react-redux';
import { fetchWishlist } from "./../../api/product/productAction";
import { addToCart } from "./../../api/cart/cartAction";

const mapDispatchToProps = {
    fetchWishlist,
    addToCart
};

const mapStateToProps = state => ({
    isLoading: state.productPage.isLoading,
    wishlist: state.productPage.wishlist
});

export const WishlistContainer = connect(mapStateToProps, mapDispatchToProps)(WishlistPage);